import {FC, PropsWithChildren} from 'react';
import style from './style.module.scss';
import {Button} from 'components/Button';
import {Typography} from 'components/Typography';
import {TPropsWithClassName} from 'core/types';
import Icon from 'components/Icon';
import cs from 'classnames';

interface IProps {
    title?: string;
    onClose?: () => void;
    classNames?: {
        title?: string;
        closeButton?: string;
    };
}

export const MobileModal: FC<TPropsWithClassName<PropsWithChildren<IProps>>> = ({
    title,
    children,
    onClose,
    className,
    classNames,
}) => {
    return (
        <>
            <div className={style.mobileModalWrapper} onClick={onClose}></div>
            <div className={cs(style.mobileModal, className)}>
                <div>
                    <Button
                        className={cs(style.close, classNames?.closeButton)}
                        leftIcon={<Icon icon={'close'} />}
                        onClick={onClose}
                        theme={'ghost'}
                    />
                    {title && (
                        <Typography className={cs(style.title, classNames?.title)} element={'div'} variant={'h2'}>
                            {title}
                        </Typography>
                    )}
                </div>
                {children}
            </div>
        </>
    );
};
